<template>
  <div class="header clearfix" :class="headerClasses">
    <div class="clearfix headerContent">
      <div class="top-logo">
        <div class="top-toHome" @click="toHome">
          <img
            v-if="showWhiteLogo"
            src="../assets/logo-w.png"
            alt="春阳台logo"
          />
          <img v-else src="../assets/logo-t.png" alt="春阳台logo" />
        </div>
      </div>

      <div class="top-right">
        <div class="lan">
          <div
            @click="changeLan(0)"
            class="changeLan"
            :class="{ lanActive: lan === 0 }"
          >
            中
          </div>
          <div
            @click="changeLan(1)"
            class="changeLan"
            :class="{ lanActive: lan === 1 }"
            v-show="shouldShowEnLan"
          >
            EN
          </div>
        </div>
      </div>

      <nav class="top-nav">
        <ul class="ul clearfix" :class="{ english: isEnglish }">
          <li
            v-for="(item, index) in headerList"
            :key="item.id"
            @click="selColumn(index)"
            @mouseenter="showSubmenuOnHover(index)"
            @mouseleave="handleMenuItemMouseLeave"
          >
            <div :class="`selColumn${index}`" :style="getColumnStyle(item)">
              {{ isEnglish ? item.enName : item.name }}
            </div>
          </li>
        </ul>
      </nav>
    </div>

    <div
      class="sub-menu"
      v-if="submenu"
      @click.stop.prevent="closeMenu"
      @mouseleave="handleSubmenuMouseLeave"
      @mouseenter="handleSubmenuMouseEnter"
    >
      <div
        class="sub-menu-content"
        v-if="!isSingleSubItem"
        :class="{ english: isEnglish }"
      >
        <!-- 只有当不是单个子菜单项时才显示子菜单内容 -->
        <div class="sub-ul" v-for="item in filteredSubList" :key="item.id">
          <!-- :class="{ aon: isCurrentSubMenuItem(item) }" 提示用户在那个页面 -->
          <div class="sub-ul-show">
            <a
              v-if="item.toId && columnShowId == 1"
              @click="goToSmooth(item.id)"
            >
              {{ isEnglish ? item.enName : item.name }}
            </a>
            <a
              v-else-if="item.id === 1 && item.requestTo === 'aboutCY'"
              @click="goToSameRoute(item.id)"
            >
              {{ isEnglish ? item.enName : item.name }}
            </a>
            <router-link
              v-else
              :to="{ name: item.requestTo, query: { columnId: item.id } }"
              >{{ isEnglish ? item.enName : item.name }}</router-link
            >
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="!showWhiteLogo"
      id="overlay"
      class="overlay"
      @click.stop="closeMenu"
    ></div>
  </div>
</template>

<script>
import { showToast } from "../utils/js/toast.js";

export default {
  name: "Header",
  props: {
    index: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      isIndex: this.index,
      headerList: [
        // 关于春阳台
        {
          id: 1,
          name: "关于春阳台",
          enName: "About CYT",
          requestTo: "aboutCY",
          subList: [
            {
              id: 1,
              name: "春阳台概况",
              enName: "About CYT",
              requestTo: "aboutCY",
              toId: false,
            },
            {
              id: 11,
              name: "特色空间",
              enName: "Space",
              requestTo: "aboutCY",
              toId: true,
            },
            {
              id: 12,
              name: "关于建筑",
              enName: "Architecture",
              requestTo: "aboutCY",
              toId: true,
            },
          ],
        },
        // 展览
        {
          id: 2,
          name: "展览",
          enName: "Exhibitions",
          requestTo: "exhibition",
          subList: [
            {
              id: 2,
              name: "正在展出",
              enName: "On Now",
              requestTo: "exhibition",
              toId: false,
            },
            {
              id: 21,
              name: "过往展出",
              enName: "Past",
              requestTo: "previousExhibitions",
              toId: false,
            },
          ],
        },
        // 活动
        {
          id: 3,
          name: "活动",
          enName: "Events",
          requestTo: "activityList",
          subList: [
            {
              id: 3,
              name: "展览项目",
              enName: "Exhibition Events",
              requestTo: "activityList",
              toId: false,
            },
            {
              id: 31,
              name: "学术活动",
              enName: "Academic",
              requestTo: "scienceActive",
              toId: false,
            },
            {
              id: 32,
              name: "研学与公教活动",
              enName: "Research and Education",
              requestTo: "researchEducation",
              toId: false,
            },
            {
              id: 33,
              name: "公共活动",
              enName: "Public",
              requestTo: "publicActivities",
              toId: false,
            },
            {
              id: 34,
              name: "品牌活动",
              enName: "Brand",
              requestTo: "brandActivity",
              toId: false,
            },
          ],
        },
        // 研究
        {
          id: 4,
          name: "研究",
          enName: "Research",
          requestTo: "study",
          subList: [
            {
              id: 4,
              name: "春阳典藏",
              enName: "Research",
              requestTo: "study",
              toId: false,
            },
          ],
        },
        // 文创
        {
          id: 7,
          name: "文创",
          enName: "Culture-Themed Products",
          requestTo: "culturalCreative",
          subList: [
            {
              id: 7,
              name: "文创商店",
              enName: "Culture-Themed Products",
              requestTo: "culturalCreative",
              toId: false,
            },
          ],
        },
        // 报头
        {
          id: 5,
          name: "塱头",
          enName: "About Langtou",
          requestTo: "rural",
          subList: [
            {
              id: 51,
              name: "项目大事记",
              enName: "Memorabilia",
              requestTo: "Memorabilia",
              toId: false,
            },
            {
              id: 5,
              name: "项目概况",
              enName: "Overview",
              requestTo: "rural",
              toId: false,
            },
            {
              id: 52,
              name: "古村展览",
              enName: "Exhibitions",
              requestTo: "currentExhibition",
              toId: false,
            },
            // AI-Generated Begin
            {
              id: 54,
              name: "国际驻留",
              enName: "Residency",
              requestTo: "educationCentre",
              toId: false,
            },
            // AI-Generated End
            {
              id: 53,
              name: "住宿体验",
              enName: "Guesthouse",
              requestTo: "lodgingExperience",
              toId: false,
            },
          ],
        },
        // 参观指南
        {
          id: 6,
          name: "发现更多",
          enName: "Discover More",
          requestTo: "visitor",
          subList: [
            {
              id: 61,
              name: "参观指南",
              enName: "Visitor Guide",
              requestTo: "visitor",
              toId: false,
            },
            {
              id: 62,
              name: "成为会员",
              enName: "Membership",
              requestTo: "Membership",
              toId: false,
            },
            {
              id: 63,
              name: "媒体中心",
              enName: "Press Releases",
              requestTo: "pressReleases",
              toId: false,
            },
            {
              id: 64,
              name: "数字资料",
              enName: "Digital Assets",
              requestTo: "digitalAssets",
              toId: false,
            },
          ],
        },
      ],
      lan: this.$store.state.isEn,
      isLoaded: this.$store.state.isLoaded,
      columnId: "",
      nowScrollToTop: 0,
      submenu: false,
      columnIndex: 0,
      columnShowId: 0,
      showScroll: false,
      mouseLeaveTimer: null,
      keepSubmenu: false, // 新增状态，用于控制是否保持子菜单显示
    };
  },

  computed: {
    isEnglish() {
      return this.lan === 1;
    },

    showWhiteLogo() {
      return this.nowScrollToTop < 20 && !this.showScroll;
    },

    shouldShowEnLan() {
      // 始终显示英文语言选项
      return true;
    },

    filteredSubList() {
      if (!this.headerList[this.columnIndex]) return [];

      // 显示所有菜单项，包括大事记
      return this.headerList[this.columnIndex].subList;
    },

    headerClasses() {
      return {
        scroll: this.nowScrollToTop >= 19 || this.showScroll,
        submenuChange:
          this.submenu && this.nowScrollToTop <= 20 && !this.showScroll,
      };
    },

    // 判断当前菜单项是否只有一个子菜单
    isSingleSubItem() {
      return (
        this.headerList[this.columnIndex] &&
        this.headerList[this.columnIndex].subList.length === 1
      );
    },
  },

  watch: {
    "$store.state.isEn"(newVal) {
      this.lan = newVal;
    },

    "$store.state.isLoaded"(newVal) {
      this.isLoaded = newVal;
    },

    submenu: {
      handler(newValue) {
        this.toggleOverlay();
      },
      deep: true,
    },

    showWhiteLogo: {
      handler() {
        // 当 showWhiteLogo 改变时也需要更新 overlay
        if (this.submenu) {
          this.$nextTick(() => {
            this.toggleOverlay();
          });
        }
      },
    },
  },

  created() {
    this.initLanguage();
  },

  mounted() {
    this.initColumnId();
    this.updateSubMenuBorder();
    // 使用节流优化滚动事件性能
    this.throttledHandleScroll = this.throttle(this.handleScroll, 100);
    window.addEventListener("scroll", this.throttledHandleScroll);
  },

  beforeDestroy() {
    window.removeEventListener("scroll", this.throttledHandleScroll);
    if (this.mouseLeaveTimer) {
      clearTimeout(this.mouseLeaveTimer);
    }
  },

  methods: {
    // 节流函数，优化滚动性能
    throttle(func, delay) {
      let timeoutId;
      let lastExecTime = 0;
      return function (...args) {
        const currentTime = Date.now();

        if (currentTime - lastExecTime > delay) {
          func.apply(this, args);
          lastExecTime = currentTime;
        } else {
          clearTimeout(timeoutId);
          timeoutId = setTimeout(() => {
            func.apply(this, args);
            lastExecTime = Date.now();
          }, delay - (currentTime - lastExecTime));
        }
      };
    },

    initLanguage() {
      let lan;
      const urlLan = this.$route.query.lan;

      // 语言映射表
      const langMap = { EN: 1, CN: 0 };

      if (urlLan !== undefined) {
        const normalized = String(urlLan).toUpperCase();
        lan = langMap.hasOwnProperty(normalized)
          ? langMap[normalized]
          : parseInt(normalized, 10) || 0;
      } else {
        try {
          lan = JSON.parse(localStorage.getItem("lan")) || 0;
        } catch (e) {
          console.error("本地语言解析失败:", e);
          lan = 0;
        }
      }

      this.lan = lan;
      this.$store.commit("changeLan1", this.lan);
    },

    initColumnId() {
      let columnId = this.$route.query.columnId;
      if (columnId === undefined) {
        columnId = 38;
      }

      // 控制页面顶部是否展示为滚动效果
      const scrollColumns = [
        1, 11, 13, 12, 2, 23, 21, 3, 31, 32, 33, 34, 35, 4, 41, 5, 51, 52, 53,
        54, 55, 6, 61,62,63,64,65,7,
      ];

      this.showScroll = scrollColumns.includes(Number(columnId));

      // 控制头部页面类型选择
      const columnMap = {
        1: [1, 11, 12, 13],
        2: [2, 23, 21],
        3: [3, 31, 32, 33, 34, 35],
        4: [4, 41],
        5: [5, 52, 53, 54, 55],
        51: [51],
        6: [6, 61,62,63,64,65],
        7: [7],
      };

      for (const [showId, ids] of Object.entries(columnMap)) {
        if (ids.includes(Number(columnId))) {
          this.columnShowId = Number(showId);
          break;
        }
      }

      // 延迟执行滚动操作，确保页面元素已加载
      if ([11, 12].includes(Number(columnId))) {
        this.$nextTick(() => {
          setTimeout(() => {
            if (columnId == 11) {
              const keySpaceElement = document.getElementById("keySpace");
              keySpaceElement?.scrollIntoView({ behavior: "smooth" });
            }
            if (columnId == 12) {
              const architectureElement =
                document.getElementById("architecture");
              architectureElement?.scrollIntoView({ behavior: "smooth" });
            }
          }, 100);
        });
      }

      this.columnId = columnId;
    },

    handleScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.nowScrollToTop = Math.floor(scrollTop);
      this.updateSubMenuBorder();
    },

    getColumnStyle(item) {
      const isActive =
        item.id == this.columnShowId ||
        (item.id == 5 && this.columnShowId == 51);

      return {
        color: isActive ? "#CA9D76" : "",
        fontWeight: isActive ? "bold" : "Regular",
      };
    },

    changeLan(lang) {
      if (this.lan === lang) return;

      this.$store.commit("changeLan");
      this.lan = this.$store.state.isEn;
      localStorage.setItem("lan", this.lan);

      // 在详情页切换语言时返回上一级页面
      if (this.$route.matched[1]?.meta.title === "detail") {
        let id;
        try {
          id = JSON.parse(localStorage.getItem("columnId"));
        } catch (e) {
          console.log(e);
        }

        this.$router
          .push({
            path: this.$route.matched[0].path,
            query: { columnId: id },
          })
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              throw err;
            }
          });
      }
    },

    toggleOverlay() {
      const overlay = document.getElementById("overlay");
      if (overlay) {
        overlay.style.display = this.submenu ? "block" : "none";
      }
    },

    selColumn(index) {
      const item = this.headerList[index];

      // 无论子菜单数量多少，都直接跳转到第一个子菜单项对应的页面
      this.$router
        .push({
          name: item.subList[0].requestTo,
          query: { columnId: item.subList[0].id },
        })
        .catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            throw err;
          }
        });
    },

    closeMenu() {
      this.submenu = false;
      this.keepSubmenu = false; // 关闭菜单时重置keepSubmenu状态
      this.updateSubMenuBorder();
    },

    toHome() {
      window.scrollTo(0, 0);
      this.$router
        .push({
          name: "Home",
          query: { columnId: 38 },
        })
        .catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            throw err;
          }
        });
    },

    goToSameRoute(id) {
      this.submenu = false;

      // 对于春阳台概况（id=1），滚动到顶部锚点
      if (id === 1) {
        const element = document.getElementById("aboutCYTop");
        element?.scrollIntoView({ behavior: "smooth" });
        // 更新URL但不刷新页面
        this.$router
          .replace({
            name: "aboutCY",
            query: { columnId: id },
          })
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              throw err;
            }
          });
        return;
      }

      // 对于其他锚点，使用goToSmooth方法
      this.goToSmooth(id);
    },

    goToSmooth(id) {
      this.submenu = false;

      const elementMap = {
        11: "keySpace",
        12: "architecture",
      };

      const elementId = elementMap[id];
      if (elementId) {
        const element = document.getElementById(elementId);
        element?.scrollIntoView({ behavior: "smooth" });
      }
    },

    showSubmenuOnHover(index) {
      // 清除之前设置的定时器，防止菜单被意外关闭
      if (this.mouseLeaveTimer) {
        clearTimeout(this.mouseLeaveTimer);
        this.mouseLeaveTimer = null;
      }

      const item = this.headerList[index];

      // 设置当前索引
      this.columnIndex = index;

      // 如果该菜单项会直接跳转（只有一个子菜单项）
      if (item.subList.length === 1) {
        // 设置keepSubmenu为true，保持黑色背景条存在，但不显示子菜单内容
        this.keepSubmenu = true;
        this.submenu = true;
        this.updateSubMenuBorder();
        this.$nextTick(() => {
          this.toggleOverlay();
          const selector = `.selColumn${index}`;
          const box = document.querySelector(selector);
          const subContent = document.querySelector(".sub-menu-content");

          if (box && subContent) {
            const rect = box.getBoundingClientRect();
            box.style.color = "#ca9d76";
            subContent.style.left = `${rect.left - 15}px`;
          }
        });
        return;
      }

      // 只有在已经有子菜单打开的情况下，或者在桌面端才响应hover事件
      if (this.submenu || window.innerWidth > 768) {
        // 设置当前索引并显示子菜单
        this.columnIndex = index;
        this.submenu = true;
        this.keepSubmenu = false; // 重置keepSubmenu状态
        this.updateSubMenuBorder();

        this.$nextTick(() => {
          this.toggleOverlay();
          const selector = `.selColumn${index}`;
          const box = document.querySelector(selector);
          const subContent = document.querySelector(".sub-menu-content");

          if (box && subContent) {
            const rect = box.getBoundingClientRect();
            box.style.color = "#ca9d76";
            subContent.style.left = `${rect.left - 15}px`;
          }
        });
      }
    },

    handleMenuItemMouseLeave() {
      // 添加延时，让用户有机会移动到子菜单上
      // 但如果keepSubmenu为true，则不关闭菜单
      if (!this.keepSubmenu) {
        this.mouseLeaveTimer = setTimeout(() => {
          this.submenu = false;
        }, 300);
      }
    },

    handleSubmenuMouseLeave() {
      // 鼠标离开子菜单时关闭菜单
      // 但如果keepSubmenu为true，则不关闭菜单
      if (!this.keepSubmenu) {
        this.submenu = false;
      }
    },

    handleSubmenuMouseEnter() {
      // 鼠标进入子菜单时清除关闭定时器
      if (this.mouseLeaveTimer) {
        clearTimeout(this.mouseLeaveTimer);
        this.mouseLeaveTimer = null;
      }
      // 鼠标进入子菜单时重置keepSubmenu状态
      this.keepSubmenu = false;
    },

    // 根据背景颜色动态设置伪元素颜色
    updateSubMenuBorder() {
      this.$nextTick(() => {
        const ulElements = document.querySelectorAll(".header ul");
        ulElements.forEach((ul, index) => {
          // 判断是否处于黑色背景状态
          const isSubmenuChange =
            this.submenu && this.nowScrollToTop <= 50 && !this.showScroll;
          // 判断是否处于白色背景状态
          const isScrolledAndWhite = this.headerClasses.scroll;
          
          // 根据背景状态设置伪元素颜色
          if (isSubmenuChange) {
            // 黑色背景时使用白色分隔线
            ul.style.setProperty('--before-bg', 'rgba(255, 255, 255, 0.8)');
          } else if (isScrolledAndWhite) {
            // 白色背景时使用深灰色分隔线
            ul.style.setProperty('--before-bg', 'rgba(82, 82, 82, 0.6)');
          } else {
            // 透明背景时使用白色分隔线
            ul.style.setProperty('--before-bg', 'rgba(255, 255, 255, 0.4)');
          }
        });
      });
    },

    isCurrentSubMenuItem(item) {
      // 判断子菜单项是否为当前页面
      const currentColumnId = this.$route.query.columnId;
      return currentColumnId && parseInt(currentColumnId) === item.id;
    },
  },
};
</script>

<style scoped>
.header {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  min-width: 320px;
  z-index: 1000;
}

.headerContent {
  width: 1400px;
  margin: 0 auto;
}

.header .top-logo {
  float: left;
  line-height: 140px;
  max-width: 280px;
}

.header .top-logo img {
  width: 267px;
  height: 48px;
}

.header .top-right {
  float: right;
  line-height: 140px;
  transition: all 0.3s;
}

.header .top-right > div {
  float: right;
  margin-left: 8px;
}

.header .top-nav {
  float: right;
  z-index: 100;
}

.header .top-nav.show {
  right: 0;
}

.header ul {
  position: relative;
}

.header ul::before {
  content: "";
  position: absolute;
  right: -20px;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 15px;
  background-color: var(--before-bg, rgba(255, 255, 255, 0.4));
}

.header ul li {
  float: left;
  line-height: 140px;
  padding: 0 10px;
  transition: all 0.3s;
}

.header ul li:first-child {
  padding-left: 0;
}

.header ul li:last-child {
  padding-right: 0;
}

.header ul li div {
  width: 100%;
  height: 100%;
  display: block;
  font-size: 15px;
  font-weight: Regular;
  color: #fff;
  position: relative;
  cursor: pointer;
}

.header .english li {
  padding: 0 13px;
}

.header ul li div::before {
  content: "";
  background: url(../assets/diandian_highllight.png) no-repeat center;
  background-size: contain;
  position: absolute;
  bottom: 47px;
  left: 50%;
  width: 0;
  height: 4px;
  transform: translateX(-50%);
}

.header ul li:hover div::before,
.header ul li.aon div::before {
  width: 20px;
  transition: all 0.3s;
}

.header .lan {
  position: relative;
  overflow: hidden;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: right;
  width: 80px;
  font-family: SourceHanSansCN-Bold;
  font-size: 15px;
  color: #fff;
  text-align: left;
}

.lanActive {
  color: #ca9d76;
  font-weight: normal;
}

.changeLan {
  width: 30px;
  height: 100%;
  text-align: center;
  font-weight: normal;
}

.sub-menu {
  position: relative;
  height: auto;
  min-height: 30px;
  color: #fff;
  animation: fadeIn 0.5s;
  z-index: 1;
}

.sub-menu-content {
  position: absolute;
  left: -50%;
  transform: translateX(-40px);
  padding: 0 60px 40px;
  width: auto;
  min-width: 200px;
  max-width: 350px;
  background-color: #000;
}

.sub-menu-content::after {
  content: "";
  position: absolute;
  bottom: -8px;
  left: 0;
  right: 0;
  margin: auto;
  width: 100%;
  height: 10px;
  background: url(../assets/home_menu_black.png) no-repeat center;
  background-size: cover;
}

.scroll .sub-menu-content {
  background-color: #fff;
}

/* 滚动状态下的弧形边框 */
.scroll .sub-menu-content::after {
  background: url(../assets/home_menu_withe.png) no-repeat center;
  background-size: cover;
}

.sub-ul {
  transition: all 0.3s;
}

.sub-ul .sub-ul-show {
  font-family: SourceHanSansCN-Medium;
  font-size: 22px;
  letter-spacing: 0;
  font-weight: 500;
  color: #fff;
  width: 100%;
  margin-top: 25px;
  word-break: break-word;
  line-height: 1.4;
}

.header .sub-ul-show a {
  position: relative;
  display: inline-block;
  text-decoration: none;
  color: #fff;
  height: auto;
  min-height: 35px;
  padding-bottom: 2px;
  overflow: hidden;
  background-image: linear-gradient(
    to right,
    #2c2c2c 100%,
    rgba(255, 255, 255, 0) 0%
  );
  background-position: 0% 100%;
  background-repeat: no-repeat;
  background-size: 0 2px;
  transition: background-size 0.3s;
  word-break: break-word;
}

.header .sub-ul-show a:hover,
.header .sub-ul.aon .sub-ul-show a {
  transition: none;
  animation: underlineFromRight 0.3s forwards;
}

@keyframes underlineFromRight {
  0% {
    background-size: 0 2px;
  }
  100% {
    background-size: 100% 2px;
  }
}

@media (max-width: 1670px) {
  .headerContent {
    width: 1400px;
  }

  .header .lan {
    margin-right: 0px;
  }
}

@media (max-width: 1540px) {
  .headerContent {
    width: 1340px;
  }

  .header .top-nav {
    float: right;
    z-index: 110;
  }

  .header .top-logo {
    float: left;
    max-width: 280px;
  }

  .header ul li div {
    font-size: 15px;
  }
}

@media (max-width: 1440px) {
  .headerContent {
    width: 90%;
  }

  .header .top-nav {
    float: right;
    z-index: 110;
  }

  .header .top-logo {
    float: left;
    max-width: 260px;
    height: 42px;
  }

  .header ul li div {
    font-size: 14px;
  }

  .header .english li {
    padding: 0 9px;
  }

  .sub-ul .sub-ul-show {
    font-size: 16px;
  }
}

@media (max-width: 1240px) {
  .headerContent {
    width: 90%;
  }

  .header .top-nav {
    float: right;
    z-index: 110;
  }

  .header .top-logo {
    float: left;
    max-width: 220px;
    height: 36px;
  }

  .header ul li div {
    font-size: 12px;
  }

  .header .english li {
    padding: 0 6px;
  }
}

/* 屏幕滚动后的处理 */
.scroll {
  height: 94px;
  background-color: #fff;
  border-bottom: 1px solid #f2f2f2;
  z-index: 1000;
}

.scroll .auto {
  height: 94px;
}

.scroll ul li div {
  color: #000;
}

.scroll .top-logo,
.scroll .top-right,
.scroll ul li {
  line-height: 94px;
}

.scroll .sub-menu {
  height: auto;
  min-height: 30px;
  color: #000;
  z-index: 1;
}

.scroll .sub-menu-content {
  position: absolute;
  left: -50%;
  background-color: #fff;
}

.scroll .sub-ul a {
  color: #000;
}

.submenuChange {
  background-color: #000;
  height: 94px;
  color: #fff;
}

.submenuChange .top-logo,
.submenuChange .top-right,
.submenuChange ul li {
  line-height: 94px;
}

.submenuChange .sub-ul:hover a::before,
.submenuChange .sub-ul.aon a::before {
  width: 60%;
  background-color: #fff;
  transition: all 0.3s;
}

.submenuChange ul li div::before {
  bottom: 27px;
}

.sub-ul-show {
  cursor: pointer;
}

.submenuChange .sub-ul-show a {
  position: relative;
  display: inline-block;
  text-decoration: none;
  color: #fff;
  height: 35px;
  padding-bottom: 2px;
  overflow: hidden;
  background-image: linear-gradient(to left, #ffffff 0%, #ffffff 100%);
  background-position: 0% 100%;
  background-repeat: no-repeat;
  background-size: 0 2px;
  transition: background-size 0.3s;
}

.submenuChange .sub-ul-show a:hover,
.submenuChange .sub-ul.aon .sub-ul-show a {
  transition: none;
  animation: underlineFromRight 0.3s forwards;
}

.scroll ul li div::before {
  bottom: 27px;
}

.scroll .lan {
  color: #000;
}

.close-btn {
  position: absolute;
  bottom: -50px;
  width: 50px;
  height: 30px;
  margin-left: 5px;
  text-align: center;
  cursor: pointer;
}

.close-btn img {
  width: 24px;
  height: 24px;
}

.overlay {
  position: fixed;
  top: 95px;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  display: none;
  z-index: 0;
}

.top-toHome {
  cursor: pointer;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>